module.exports = __webpack_public_path__ + "@/assets/img/05.3ae3daaa.svg";